
import qs from "qs";
import { useHistory } from 'react-router-dom';

export default (prop) => {
  const history = useHistory()
  let query = qs.parse(history.location.search, { ignoreQueryPrefix: true })
  console.log('location.href', location.href)
  //https://gc-access-beta2.shrise.cn/o2n?path=register%3Fredirect%3Dhttp%3A%2F%2Flocalhost%3A8868%2Fsk%2Fpersonal&wxId=663

  if (query.path) {
    let url = query.path;
    // if (query.param) {
    //   url = `${url}?param=${JSON.stringify(query.param)}`
    // }
    if(!url.startsWith("/")){
      url = "/" + url
    }
    let searchIndex = url.indexOf('?');
    if(searchIndex>=0){
      history.push({
        pathname: url.slice(0, searchIndex),
        search: url.slice(searchIndex+1),
      })
    }else {
      history.push({
        pathname: url
      })
    }

  }

  return null;
};
